import React from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup as MUIRadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  RadioGroupProps as MUIRadioGroupProps,
  styled
} from '@mui/material';

export interface RadioOption {
  value: string;
  label: string;
}

export interface RadioGroupProps extends MUIRadioGroupProps {
  /** Group label */
  label?: string;
  /** Radio options */
  options: RadioOption[];
  /** Helper text */
  helperText?: React.ReactNode;
  /** Error state */
  error?: boolean;
  /** Error message */
  errorText?: string;
  /** Radio layout direction */
  row?: boolean;
}

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  options,
  helperText,
  error = false,
  errorText,
  row = false,
  ...rest
}) => {
  const displayHelperText = error && errorText ? errorText : helperText;
  return (
    <StyledFormControl error={error}>
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <MUIRadioGroup row={row} {...rest}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </MUIRadioGroup>
      {displayHelperText && <FormHelperText>{displayHelperText}</FormHelperText>}
    </StyledFormControl>
  );
};

export default RadioGroup;
